<template>
  <div class="assembleOrder">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="SMT工单" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: cutView == true }"
            @click="cutViewChange(true)"
            >SMT工单</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button type="primary" icon="el-icon-plus" class="activeUserMore" size="small" @click="addBtn">新建</el-button>
            <el-button type="primary" icon="el-icon-sort" class="activeUserMore" size="small" @click="syncBtn">同步</el-button>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane
          v-for="(item, index) in tabPaneList"
          :key="item.id"
          :label="item.orderNumber"
          :name="item.id"
        >
          <span slot="label">
            {{ item.orderNumber }}
            <i
              class="el-icon-circle-close"
              @click.stop="closeTabPane(index)"
            ></i>
          </span>
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'detail' }"
            @click="cutDetailChange('detail')"
            >工单详情</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'devices' }"
            @click="cutDetailChange('devices')"
            >PCBA列表</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'status' }"
            @click="cutDetailChange('status')"
            >生产状态</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'process' }"
            @click="cutDetailChange('process')"
            >生产工序</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'QCReport' }"
            @click="cutDetailChange('QCReport')"
            >QC记录</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'RepairRecordPage' }"
            @click="cutDetailChange('RepairRecordPage')"
            >维修记录</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: cutDetail == 'proLog' }"
            @click="cutDetailChange('proLog')"
            >生产日志</span
          >
          <span
            v-if="detailData && detailData.customer && detailData.customer.id=='148759996952887296'"
            class="childTabs"
            :class="{ activeLink: cutDetail == 'uploadLog' }"
            @click="cutDetailChange('uploadLog')"
            >上报日志</span
          >
          <div class="btnBox" v-if="cutDetail == 'devices'">
            <div class="searchBtnBox" v-if="isMoreSearch" style="margin-left:0px;">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <!-- <el-dropdown trigger="click" @command="tableExport">
                <el-button
                  class="downIcon"
                  type="primary"
                  icon="el-icon-d-arrow-right"
                  size="small"
                  >导出</el-button
                >
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="SMT测试报表">SMT测试报表</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
              <el-dropdown
                split-button
                type="primary"
                size="small"
                class="searchBox"
                @click="onSearch(false)"
                trigger="click"
              >
                查询
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="onSearch(true)"
                    >模糊查询</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'proLog'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button @click="onSearch(true)" class="downIcon" type="primary" size="small">导出</el-button>
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch(false)">查询</el-button>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'RepairRecordPage'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-button
                type="primary"
                icon="el-icon-download"
                size="small"
                @click="RepairRecordExport"
                >导出</el-button
              >
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'QCReport'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-dropdown trigger="click" @command="QCReportExport">
                <el-button class="downIcon" type="primary" icon="el-icon-d-arrow-right" size="small">导出</el-button>
                <el-dropdown-menu slot="dropdown" class="devicesDownloadDrop">
                  <el-dropdown-item command="导出报表">导出报表</el-dropdown-item>
                  <el-dropdown-item command="FQC明细报表">只导FQC人员的报表</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'uploadLog'">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch(false)">查询</el-button>
            </div>
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
          <div class="btnBox" v-else-if="cutDetail == 'process'">
           <el-button icon="el-icon-document-copy" size="small" @click="copySopBtn($event)">复制工序</el-button>
            <el-button icon="el-icon-plus" size="small" @click="addNewBtn">添加</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="searchConditionForm"
        class="demo-form-inline"
        v-if="isMoreSearch && tabPaneValue == 'first'"
        key="first"
      >
        <div class="searchConditionBox" v-if="cutView" :key="1">
          <el-form-item label="SMT工单" size="small">
            <el-input
              v-model="searchConditionForm.orderNumber"
              placeholder="SMT工单号"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="物料编码" size="small">
            <el-input
              v-model="searchConditionForm.itemCode"
              placeholder="PCBA物料编码"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注" size="small">
            <el-input
              v-model="searchConditionForm.notes"
              placeholder="备注"
              clearable
              @keyup.enter.native="getProductionOrderSearch()"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="devicesSearchForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'devices'
        "
        key="devices"
      >
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input
              v-model="devicesSearchForm.sn"
              placeholder="PCBA SN"
              clearable
              @keyup.enter.native="$refs.pcbaPage.getSmtOrderPcba()"
            ></el-input>
          </el-form-item>
          <el-form-item label="主控ID" size="small">
            <el-input
              v-model="devicesSearchForm.chipId"
              placeholder="主控ID"
              clearable
              @keyup.enter.native="$refs.pcbaPage.getSmtOrderPcba()"
            ></el-input>
          </el-form-item>
          <el-form-item label="其它SN" size="small">
            <el-input
              v-model="devicesSearchForm.parentSn"
              placeholder="其它SN"
              clearable
              @keyup.enter.native="$refs.pcbaPage.getSmtOrderPcba()"
            ></el-input>
          </el-form-item>
          <el-form-item label="当前工序" size="small">
            <el-select
              v-model="devicesSearchForm.workStationId"
              placeholder="PCBA所在的工序"
              multiple
              collapse-tags
              filterable
              clearable
              @change="workStationChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productionOrderStatusList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>      
      <el-form
        :inline="true"
        :model="proLogForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue != 'first' && cutDetail == 'proLog'"
        key="proLog"
      >
        <div class="searchConditionBox">
          <el-form-item label="请求ID" size="small">
            <el-input
              :value="proLogForm.id"
              @input="idInputChange($event, 'proLogForm')"
              placeholder="Request ID"
              clearable
              @keyup.enter.native="$refs.logPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="SN" size="small">
            <el-input
              v-model="proLogForm.key"
              placeholder="PCBA SN"
              clearable
              @keyup.enter.native="$refs.logPage.getFactoryLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="proLogForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'proLogForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线体" size="small">
            <el-cascader
              :options="pullDownData.factoryOrgData"
              :props="{
                checkStrictly: true,
                emitPath: false,
                label: 'name',
                value: 'id',
              }"
              :show-all-levels="false"
              v-model="proLogForm.organizationId"
              @change="cascaderChange($event, 'factoryOrgCascader')"
              ref="factoryOrgCascader"
              placeholder="选择所在线体"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select v-model="proLogForm.workStationId" placeholder="选择工序"
              filterable clearable multiple collapse-tags>
              <el-option
                v-for="(item, index) in pullDownData.smtOrderSopList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-select
              v-model="proLogForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="proLogForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="proLogForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('proLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <!--维修记录查询条件-->
      <el-form
        :inline="true"
        :model="RepairRecordForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'RepairRecordPage'
        "
        key="RepairRecordPages"
      >
        <div class="searchConditionBox" v-if="tabPaneData.product && tabPaneData.product.productType && (tabPaneData.product.productType.code=='AI_PC' || tabPaneData.product.productType.code=='AI_SERVER')">
          <el-form-item label="SN" size="small">
            <el-input v-model="RepairRecordForm.key" placeholder="内部SN或客户SN" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="不良代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode1" placeholder="不良代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="原因代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode2" placeholder="原因代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="权责代码" size="small">
            <el-input v-model="RepairRecordForm.errorCode3" placeholder="权责代码" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="维修方式" size="small">
            <el-input v-model="RepairRecordForm.errorCode4" placeholder="维修方式" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>
          <el-form-item label="维修状态" size="small">
          <el-select v-model="RepairRecordForm.status" filterable multiple allow-create default-first-option placeholder="维修状态" clearable>
            <el-option label="待送修" value="WAIT_REPAIR"> </el-option>
            <el-option label="待维修" value="WAIT"> </el-option>
            <el-option label="维修中" value="REPAIRING"> </el-option>
            <el-option label="维修完成" value="COMPLETED"> </el-option>
            <el-option label="维修失败" value="FAIL"> </el-option>
            <el-option label="退回送修前" value="ROLLBACK"> </el-option>
          </el-select>
          </el-form-item>          
        </div>
        <div v-else>
          <el-form-item label="SN" size="small">
            <el-input v-model="RepairRecordForm.sn" placeholder="SN或MAC" clearable
              @keyup.enter.native="onSearch()" />
          </el-form-item>          
          <el-form-item label="维修开始" size="small">
            <el-date-picker
              v-model="RepairRecordForm.startDateTime"
              type="datetime"
              placeholder="维修开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="维修结束" size="small">
            <el-date-picker
              v-model="RepairRecordForm.endDateTime"
              type="datetime"
              placeholder="维修结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <!--QC记录查询条件-->
      <el-form
        :inline="true"
        :model="QCReportForm"
        class="demo-form-inline"
        v-else-if="
          isMoreSearch && tabPaneValue != 'first' && cutDetail == 'QCReport'
        "
        key="QCReport"
      >
        <div class="searchConditionBox">
          <el-form-item label="SN" size="small">
            <el-input
              v-model="QCReportForm.sn"
              placeholder="SN"
              clearable
              @keyup.enter.native="$refs.QCReportPage.getProOrderQCReport()"
            ></el-input>
          </el-form-item>
          <el-form-item label="工序" size="small">
            <el-select v-model="QCReportForm.workStationId" placeholder="选择工序"
              filterable clearable multiple collapse-tags>
              <el-option
                v-for="(item, index) in pullDownData.smtOrderSopList"
                :key="index"
                :label="item.workStation.name"
                :value="item.workStation.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测试类型" size="small">
            <el-select
              v-model="QCReportForm.type"
              placeholder="选择测试类型"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.QCTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="测试对象" size="small">
            <el-select
              v-model="QCReportForm.targetType"
              placeholder="选择测试对象"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in pullDownData.QCTargetTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工" size="small">
            <el-select
              v-model="QCReportForm.userId"
              placeholder="选择员工"
              filterable
              clearable
              class="hiddenSelectDropdown"
              :popper-append-to-body="false"
              @visible-change="
                selectVisible($event, 'user', '员工选择', 'QCReportForm')
              "
            >
              <el-option
                v-for="(item, index) in pullDownData.userList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-select
              v-model="QCReportForm.code"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="QCReportForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateTimeChange('QCReportForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="QCReportForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateTimeChange('QCReportForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <!--上报日志查询条件-->
      <el-form :inline="true" :model="uploadLogForm" class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue != 'first' && cutDetail == 'uploadLog'" key="uploadLog">
        <div class="searchConditionBox">
          <el-form-item label="RequestId" size="small">
            <el-input
              v-model="uploadLogForm.requestId"
              placeholder="输入RequestId"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="SN" size="small">
            <el-input
              v-model="uploadLogForm.sn"
              placeholder="输入SN"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Action" size="small">
            <el-input
              v-model="uploadLogForm.action"
              placeholder="输入Action"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="Type" size="small">
            <el-input
              v-model="uploadLogForm.type"
              placeholder="输入测试类型"
              clearable
              @keyup.enter.native="$refs.UploadLogPage.getUploadLogSearch()"
            ></el-input>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-select
              v-model="uploadLogForm.errorCode"
              filterable
              allow-create
              default-first-option
              placeholder="错误代码"
              clearable
            >
              <el-option label="所有错误" value="-99998"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" size="small">
            <el-date-picker
              v-model="uploadLogForm.startDateTime"
              type="datetime"
              placeholder="开始时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="startDateChange('uploadLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" size="small">
            <el-date-picker
              v-model="uploadLogForm.endDateTime"
              type="datetime"
              placeholder="结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              @change="endDateChange('uploadLogForm')"
              :picker-options="$store.state.pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="contentBox" v-if="tabPaneValue == 'first'">
      <div class="rightContent">
        <div class="tableView" :key="2">
          <el-table stripe border style="width: 100%" height="100%" size="mini"
            :data="tableData" @sort-change="sortChange">
            <el-table-column align="center" type="index"
              :width="pagination.endIndex >= 1000 ? 80 : 50" :index="pagination.beginIndex">
            </el-table-column>
            <el-table-column align="center" min-width="120px" sortable="custom"
              label="SMT单号" prop="orderNumber">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="'ID: '+scope.row.id" placement="top" :open-delay="300">
                  <span class="textOverflow allowSkip" @click="clickAllowSkip(scope.row)">{{scope.row.orderNumber}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column lign="center" min-width="125px" show-overflow-tooltip
              label="物料编码" prop="itemCode">
              <template slot-scope="scope">
                <span v-if="scope.row.itemCode">{{ scope.row.itemCode }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column align="center" min-width="125px" show-overflow-tooltip
              label="产品型号" prop="product">
              <template slot-scope="scope">
                <span v-if="scope.row.product">{{ scope.row.product.code }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column align="center" max-width="95px" show-overflow-tooltip
              label="工单数量" prop="quantity">
            </el-table-column>
            <el-table-column align="center" max-width="95px" show-overflow-tooltip
              label="已测数量" prop="testQuantity">
            </el-table-column>
            <el-table-column align="center" max-width="95px" show-overflow-tooltip
              label="直通率" prop="rty">
            </el-table-column>
            <el-table-column align="center" min-width="110" show-overflow-tooltip
              label="备注" prop="notes">
              <template slot-scope="scope">
                <span v-if="scope.row.notes">{{ scope.row.notes }}</span>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :pagination="pagination"
            @currentChange="currentChange"
            @sizeChange="sizeChange"
            @refreshBtn="getProductionOrderSearch"
          ></pagination>
        </div>
      </div>
    </div>
    <div class="contentBox" v-else>
      <div class="rightContent" v-if="cutDetail != 'process'">
        <detailPage
          ref="detailPage"
          v-if="cutDetail == 'detail'"
          :tabPaneValue="tabPaneValue"
        ></detailPage>
        <pcbaPage
          ref="pcbaPage"
          v-else-if="cutDetail == 'devices'"
          :tabPaneValue="tabPaneValue"
          :devicesSearchForm="devicesSearchForm"
        ></pcbaPage>
        <div class="chartView" v-else-if="cutDetail == 'status'">
          <div class="echartBtn">
            <el-button style="min-width: 100px"
              :type="proStatus == '产品状态' ? 'primary' : ''" size="small" @click="cutProStatus('产品状态')">
              生产状态
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == '异常统计' ? 'primary' : ''" size="small" @click="cutProStatus('异常统计')">
              异常统计
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == 'Top10日报' ? 'primary' : ''" size="small" @click="cutProStatus('Top10日报')">
              Top10日报
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == 'Top10时报' ? 'primary' : ''" size="small" @click="cutProStatus('Top10时报')">
              Top10时报
            </el-button>
            <el-button style="min-width: 100px"
              :type="proStatus == '维修Top5日报' ? 'primary' : ''" size="small" @click="cutProStatus('维修Top5日报')">
              维修Top5日报
            </el-button>
          </div>
          <div v-if="proStatus == '产品状态'"
            class="statusEchart" ref="statusEchart" key="statusEchart">
          </div>
        </div>
        <logPage
          ref="logPage"
          v-else-if="cutDetail == 'proLog'"
          :tabPaneValue="tabPaneValue"
          :proLogForm="proLogForm"
        ></logPage>
        <RepairRecordPage
          ref="RepairRecordPage"
          v-else-if="cutDetail == 'RepairRecordPage'"
          :tabPaneValue="tabPaneValue"
          :tabPaneData="tabPaneData"
          :RepairRecordForm="RepairRecordForm"
        ></RepairRecordPage>
        <QCReportPage
          ref="QCReportPage"
          v-else-if="cutDetail == 'QCReport'"
          :tabPaneValue="tabPaneValue"
          :QCReportForm="QCReportForm"
        ></QCReportPage>
        <UploadLogPage
          ref="UploadLogPage"
          v-else-if="cutDetail == 'uploadLog'"
          :tabPaneValue="tabPaneValue"
          :uploadLogForm="uploadLogForm"
        ></UploadLogPage>
      </div>
      <sopPage
        ref="sopPage"
        v-else-if="cutDetail == 'process'"
        :tabPaneValue="tabPaneValue"
        :tabPaneData="tabPaneData"
      ></sopPage>
    </div>
    <orderTableSelect
      ref="orderTableSelect"
      @orderTableSubmit="orderTableSubmit"
    ></orderTableSelect>

    <myDialog ref="myDialog" width="520px" title="新建SMT工单"
      @dialogClose="addSmtOrderClose" @submitData="addSmtOrderData">
      <template slot="content">
        <el-form ref="dialogForm"
          :model="dialogForm" :rules="addRules" :label-width="labelWidth">
          <el-form-item label="试产单号" size="small" prop="orderNumber">
              <el-input v-model="dialogForm.orderNumber" placeholder="试产单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="物料编码" size="small" prop="itemCode">
              <el-input v-model="dialogForm.itemCode" placeholder="物料编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="数量" size="small" prop="quantity">
              <el-input v-model="dialogForm.quantity" placeholder="数量" clearable
                @input="$event => $set(dialogForm, 'quantity', $event.replace(/[^\d]/g,'').replace(/^0{1,}/g,''))">
              </el-input>
          </el-form-item>
          <el-form-item label="备注" size="small">
              <el-input v-model="dialogForm.notes" placeholder="备注" clearable></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import * as echarts from "echarts";
import detailPage from "./components/detailPage.vue";
import pcbaPage from "./components/pcbaPage.vue";
import sopPage from "./components/sopPage.vue";
import logPage from "./components/logPage.vue";
import RepairRecordPage from "./components/RepairRecordPage.vue";
import QCReportPage from "./components/QCReportPage.vue";
import UploadLogPage from "./components/uploadLogPage.vue";
import orderTableSelect from "@/components/orderTableSelect.vue";
import {
  apiWorkStationList, apiQCTypeList, apiQCTargetTypeList
} from "@/api/productionOrder.js";
import {
  apiSmtOrderSync, apiSmtOrderSearch, apiSmtOrderPcbaStatusList, apiSmtOrderPcbaStatus,
  apiSmtOrderSopList,apiSmtOrderAdd
} from "@/api/SmtOrder.js"
import { apiFactoryOrgShow } from "@/api/productSystem.js";
export default {
  lastModuleConfig: { modulePath: "/homePage/smtOrder", subTabs: { cutView: [true, false] } },
  components: {
    pagination,
    detailPage,
    myDialog,
    pcbaPage,
    sopPage,
    logPage,
    RepairRecordPage,
    QCReportPage,
    UploadLogPage,
    orderTableSelect,
  },
  computed: {
  },
  data() {
    return {
      dialogForm: {},
      dialogTitle: "",
      dialogRules: {
        userId: [
          { required: true, message: "工单的新所有者不能为空！", trigger: "change" },
        ],
        date: [
          {
            required: true,
            message: "交货日期不能为空！",
            trigger: "change",
          },
        ],
      },
      smtSopData: null,
      textvalue: "",
      tabPaneList: [],
      tabPaneValue: "first",
      tabPaneData: {},
      isMoreSearch: false,
      searchConditionForm: {},
      detailData: {},
      detailStatus: {}, // 详情状态
      devicesSearchForm: {},
      uploadType: "file",
      HandoverForm: {},
      inspectionForm:{},
      proLogForm: {},
      RepairRecordForm: {},
      QCReportForm: {},
      uploadLogForm: {},
      isShowTips: true,
      pullDownData: {
        customerList: [],
        productTypeList: [],
        productList: [],
        productionOrderStatusList: [],
        productionOrderStatusList2: [],
        workStationList: [],
        factoryOrgData: [],
        smtOrderSopList: [],
        QCTypeList: [],
        QCTargetTypeList: [],
        userList: [], // 员工列表
      },
      addRules: {
        orderNumber: [
          { required: true, message: "试产单号不能为空！", trigger: "change" },
        ],
        itemCode: [
          { required: true, message: "物料编码不能为空！", trigger: "change" },
        ],
        quantity: [
          { required: true, message: "数量不能为空！", trigger: "change" },
        ]
      },
      cutView: true,
      echartType: "柱状图",
      proStatus: "产品状态",
      cutDetail: "detail",
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      labelWidth: this.$store.state.labelWidth,
      nowRowData: {},
      currentProcessKey: "",
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      if (newVal == "first") {
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        this.$nextTick(() => {
          this.tabPaneList.forEach((item) => {
            if (item.id == newVal) {
              this.tabPaneData = item;
            }
          });
          if (this.cutDetail == "detail") {
            this.$refs.detailPage.getSmtOrderDetail();            
          } else if (this.cutDetail == "devices") {
            this.$set(this.devicesSearchForm, "workStationId", undefined);
            this.$refs.pcbaPage.pagination.currentPage = 1;
            this.$refs.pcbaPage.getSmtOrderPcba(
              "",
              this.getSmtOrderPcbaStatusList
            );
          } else if (this.cutDetail == "status") {
            this.cutProStatus(this.proStatus);
          } else if (this.cutDetail == "process") {
            this.$refs.sopPage.currentProcessKey = this.currentProcessKey;
            this.$refs.sopPage.getSmtOrderSopSearch();
          } else if (this.cutDetail == "proLog") {
            this.$set(this.proLogForm, "workStationId", undefined);
            this.$refs.logPage.getFactoryLogSearch("", false, this.getProductSopList);
          } else if (this.cutDetail == "QCReport") {
            this.$refs.QCReportPage.getProOrderQCReport();
            this.getProductSopList();
          } else if (this.cutDetail == "uploadLog") {
            this.$refs.UploadLogPage.getUploadLogSearch("");
          } else if (this.cutDetail == "RepairRecordPage") {
            this.$refs.RepairRecordPage.getRepairSearch();
          }
        });
      }
    },
  },
  methods: {
    addSmtOrderClose(){
      this.$refs.dialogForm.resetFields();
      this.dialogForm = { notes: null };
    },
    addSmtOrderData(){
      this.$refs.dialogForm.validate(async valid => {
        if (valid) {
          const res = await apiSmtOrderAdd({
              ...this.dialogForm
            });
            if (res.code == 0) {
              this.onSearch();
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: "新建成功",
                type: "success"
              });
            } else if(res.code == 1024) {
              this.onSearch();
              this.$refs.myDialog.dialogVisible = false;
              this.$message({
                message: res.msg,
                type: "success"
              });
            }
        } else {
          return false;
        }
      });
    },
    addBtn(){
      this.dialogTitle = "新建SMT工单";
      this.$refs.myDialog.dialogVisible = true;

      // var inputOrderNum=null;
      // const h = this.$createElement;
      // this.$msgbox({
      //   title: `请输入SMT工单号`,
      //   message: h("div", null, [
      //     h("span", null, `同步SMT工单及PCBA SN`)
      //   ]),
      //   showCancelButton: true,
      //   confirmButtonText: `同步`,
      //   cancelButtonText: "取消",
      //   closeOnClickModal: false,
      //   showInput: true,
      //   beforeClose: (action, instance, done) => {
      //     inputOrderNum = instance.inputValue;
      //     done();
      //   },
      // }).then(async () => {
      //   const res = await apiSmtOrderAdd({
      //     orderNumber: inputOrderNum
      //   });
      //   // console.log(res);
      //   if (res.code == 0) {
      //     this.$message({
      //       message: "工单【"+inputOrderNum+"】同步成功！",
      //       type: "success"
      //     });
      //   }

      //   this.getProductionOrderSearch();
      // });
    },
    syncBtn() {
      var inputOrderNum=null;
      const h = this.$createElement;
      this.$msgbox({
        title: `请输入SMT工单号`,
        message: h("div", null, [
          h("span", null, `如果是Mike和Boo的PCBA请输入SAP的工单号，其它请输入盘古IMS的主计划！`)
        ]),
        showCancelButton: true,
        confirmButtonText: `同步`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          inputOrderNum = instance.inputValue;
          done();
        },
      }).then(async () => {        
        const res = await apiSmtOrderSync({
          orderNumber: inputOrderNum
        });
        // console.log(res);
        if (res.code == 0) {        
          this.$message({
            message: "工单【"+inputOrderNum+"】同步成功！",
            type: "success"
          });
        }
        
        this.getProductionOrderSearch();
      });
    },
    // 对话框提交
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          return title;          
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.HandoverForm = {};
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 关闭一级面板
    closeTabPane(index) {
      if (this.tabPaneList[index].id == this.tabPaneValue) {
        if (index > 0) {
          this.tabPaneValue = this.tabPaneList[index - 1].id;
        } else {
          this.tabPaneValue = "first";
        }
      }
      this.tabPaneList.splice(index, 1);
    },
    // 组装工单-切换视图
    cutViewChange(value) {
      this.cutView = value;
      if (value) {
        this.getProductionOrderSearch();
      } else {
        this.getProductionOrderCountByStatus();
      }
      this.$moreSearchStyle();
    },
    // 图表视图-切换图表类型
    echartCutBtn(type) {
      this.echartType = type;
      this.getProductionOrderCountByStatus();
    },
    // 切换详情-二级面板
    cutDetailChange(value) {
      this.cutDetail = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (value == "detail") {
          this.$refs.detailPage.getSmtOrderDetail();
        } else if (value == "devices") {
          this.$refs.pcbaPage.getSmtOrderPcba(
            "",
            this.getSmtOrderPcbaStatusList
          );
        } else if (this.cutDetail == "status") {
          this.cutProStatus(this.proStatus);
        } else if (value == "process") {
          this.$refs.sopPage.currentProcessKey = this.currentProcessKey;
          this.$refs.sopPage.getSmtOrderSopSearch();
        } else if (this.cutDetail == "proLog") {
          this.$refs.logPage.getFactoryLogSearch("", false, this.getProductSopList);
        } else if (this.cutDetail == "QCReport") {
          this.$refs.QCReportPage.getProOrderQCReport();
          this.getProductSopList();
        } else if (this.cutDetail == "uploadLog") {
          this.$refs.UploadLogPage.getUploadLogSearch("");
        } else if (this.cutDetail == "RepairRecordPage") {
          this.$refs.RepairRecordPage.getRepairSearch();
        }
      });
    },
    // 表格数据
    async getProductionOrderSearch(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiSmtOrderSearch({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 生产状态--切换图表
    cutProStatus(value, callback) {
      this.proStatus = value;
      if (value == "产品状态") {
        this.getSmtOrderPcbaStatus(callback);
      }      
    },
    // 产品状态
    async getSmtOrderPcbaStatus(callback) {
      const res = await apiSmtOrderPcbaStatus({
        id: this.tabPaneValue,
      });
      // console.log(res);
      if (res.code == 0) {
        let allCount = 0;
        res.data.forEach((item) => (allCount += item.count));
        let legendData = res.data.map(
          (item) => item.workStation.name + "：" + item.count + "PCS"
        );
        let seriesData = res.data.map((item) => {
          return {
            value: item.count,
            name: item.workStation.name + "：" + item.count + "PCS",
            tooltip: {
              formatter: "{a}<br />{b}：{d}%",
            },
          };
        });
        let myEchart = echarts.init(this.$refs.statusEchart);
        myEchart.clear();
        let option = {
          backgroundColor: "#fff",
          color: [
            "#dd6b66",
            "#759aa0",
            "#e69d87",
            "#d48265",
            "#91c7ae",
            "#749f83",
            "#ca8622",
            "#bda29a",
            "#6e7074",
            "#546570",
            "#c4ccd3",
          ],
          title: {
            text: "裸机数量：" + allCount,
            left: "center",
            textStyle: {
              color: "#303133",
            },
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b} : {c} ({d}%)",
          },
          legend: {
            orient: "vertical",
            left: "left",
            top: 30,
            data: legendData,
            textStyle: {
              color: "#303133",
            },
          },
          series: [
            {
              name: "状态",
              type: "pie",
              radius: "55%",
              center: ["50%", "60%"],
              data: seriesData,
              label: {
                color: "rgba(0, 0, 0)",
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
          // backgroundColor: "rgba(0, 0, 0, 0.5)",
        };
        myEchart.setOption(option);
        if (callback) callback();
      }
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 清除查询
    onClear() {
      if (this.tabPaneValue == "first") {
        this.searchConditionForm = {};
        this.pagination.currentPage = 1;
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm = {};
          this.$refs.pcbaPage.pagination.currentPage = 1;
          // props传参数据有延迟，需要nextTick延迟调用数据
          this.$nextTick(() => {
            this.$refs.pcbaPage.getSmtOrderPcba();
            this.$moreSearchStyle(); // 当前工序多选撑开高度
          });
        } else if (this.cutDetail == "proLog") {
          this.proLogForm = {};
          this.$refs.logPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.logPage.getFactoryLogSearch();
          });
        } else if (this.cutDetail == "QCReport") {
          this.QCReportForm = {};
          this.$refs.QCReportPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.QCReportPage.getProOrderQCReport();
          });
        } else if (this.cutDetail == "uploadLog") {
          this.uploadLogForm = {};
          this.$refs.UploadLogPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.UploadLogPage.getUploadLogSearch();
          });
        } else if (this.cutDetail == "RepairRecordPage") {
          this.RepairRecordForm = {};
          this.$refs.RepairRecordPage.pagination.currentPage = 1;
          this.$nextTick(() => {
            this.$refs.RepairRecordPage.getRepairSearch();
          });
        }
      }
    },
    // 确认查询
    onSearch(value) {
      if (this.tabPaneValue == "first") {
        this.pagination.currentPage = 1;
        if (this.cutView) {
          this.getProductionOrderSearch();
        } else {
          this.getProductionOrderCountByStatus();
        }
      } else {
        if (this.cutDetail == "devices") {
          this.devicesSearchForm.like = value;
          this.$refs.pcbaPage.pagination.currentPage = 1;
          this.$refs.pcbaPage.getSmtOrderPcba();
        } else if (this.cutDetail == "proLog") {
          this.$refs.logPage.pagination.currentPage = 1;
          this.$refs.logPage.getFactoryLogSearch(value ? "noRemove" : "", value);
        } else if (this.cutDetail == "QCReport") {
          this.$refs.QCReportPage.pagination.currentPage = 1;
          this.$refs.QCReportPage.getProOrderQCReport();
        } else if (this.cutDetail == "uploadLog") {
          this.$refs.UploadLogPage.pagination.currentPage = 1;
          this.$refs.UploadLogPage.getUploadLogSearch(value ? "noRemove" : "", value);
        } else if (this.cutDetail == "RepairRecordPage") {
          this.$refs.RepairRecordPage.pagination.currentPage = 1;
          this.$refs.RepairRecordPage.getRepairSearch();
        }
      }
    },
    // 维修记录导出
    RepairRecordExport() {
      this.$refs.RepairRecordPage.RepairRecordExport();
    },
    // qc记录导出
    QCReportExport(command) {
      this.$refs.QCReportPage.QCReportExport(command == 'FQC明细报表');
    },
    // 产品列表表格导出
    tableExport(command) {
      this.$refs.pcbaPage.tableExport(command);
    },
    // 复制工序
    copySopBtn(e) {
      if (this.cutDetail == "process") {
        this.$refs.sopPage.copySopBtn(e);
      }
    },
    // 添加按钮
    addNewBtn() {
      if (this.cutDetail == "process") {
        this.$refs.sopPage.addNewBtn();
      }
    },
    // 判断id只能输入数字
    idInputChange(value, formName) {
      this.$set(this[formName], "id", this.$formatPositive(value));
    },
    // 当前工序改变
    workStationChange() {
      setTimeout(() => {
        this.$moreSearchStyle();
      }, 100);
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 查询条件-员工
    selectVisible(value, orderName, labelName, origin) {
      if (value) {
        this.$refs.orderTableSelect.labelName = labelName;
        this.$refs.orderTableSelect.orderName = orderName;
        this.$refs.orderTableSelect.origin = origin;
        this.$refs.orderTableSelect.openDialog();
      }
    },
    // 员工选择表格提交
    orderTableSubmit({ orderName, selectRow, origin }) {
      this.$set(this[origin], `${orderName + "Id"}`, selectRow.id);
      this.$set(this.pullDownData, `${orderName + "List"}`, [selectRow]);
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProductionOrderSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProductionOrderSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProductionOrderSearch();
    },
    // 表格列组装工单点击
    clickAllowSkip(row) {
      this.nowRowData = row;
      this.tabPaneValue = row.id;
      let tabPaneIds = this.tabPaneList.map((item) => item.id);
      if (tabPaneIds.includes(row.id)) {
        this.tabPaneList.splice(tabPaneIds.indexOf(row.id), 1, row);
      } else {
        this.tabPaneList.push(row);
      }
    },
    // 产品列表-当前工序
    async getSmtOrderPcbaStatusList() {
      const res = await apiSmtOrderPcbaStatusList({
        all: true,
        id: this.tabPaneValue,
      });
      if (res.code == 0) {
        this.pullDownData.productionOrderStatusList = res.data;
      }
    },
    // 生产工序-工序下拉
    async getWorkStationList() {
      const res = await apiWorkStationList();
      if (res.code == 0) {
        this.pullDownData.workStationList = res.data;
      }
    },
    // 生产日志--线体
    async getFactoryOrg() {
      const res = await apiFactoryOrgShow();
      // console.log(res);
      if (res.code == 0) {
        this.data = res.data;
        this.pullDownData.factoryOrgData = res.data.children;
      }
    },
    // 生产日志--工序下拉
    async getProductSopList() {
      const res = await apiSmtOrderSopList({
        orderId: this.tabPaneValue,
        typeId: 0,
        all: true,
      });
      if (res.code == 0) {
        this.pullDownData.smtOrderSopList = res.data;
      }
    },
    // QC报表-测试类型下拉
    async getQCTypeList() {
      const res = await apiQCTypeList();
      if (res.code == 0) {
        this.pullDownData.QCTypeList = res.data;
      }
    },
    // QC报表-测试对象类别下拉
    async getQCTargetTypeList() {
      const res = await apiQCTargetTypeList();
      if (res.code == 0) {
        this.pullDownData.QCTargetTypeList = res.data;
      }
    },
    // 查询条件--开始日期
    startDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].endDate = this[formName].startDate;
      }
    },
    // 查询条件--结束日期
    endDateChange(formName) {
      let { startDate, endDate } = this[formName];
      if (startDate > endDate) {
        this[formName].startDate = this[formName].endDate;
      }
    },
    // 查询条件--开始日期时间
    startDateTimeChange(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].endDateTime = this[formName].startDateTime;
      }
    },
    // 查询条件--结束日期时间
    endDateTimeChange(formName) {
      let { startDateTime, endDateTime } = this[formName];
      if (startDateTime > endDateTime) {
        this[formName].startDateTime = this[formName].endDateTime;
      }
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    callback() {
      this.getWorkStationList();
      this.getFactoryOrg();
      this.getQCTypeList();
      this.getQCTargetTypeList();
    },

  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top = document.querySelector(".header").offsetHeight + "px";
    };
    if (this.tabPaneValue == "first") {
      if (this.cutView) {
        this.getProductionOrderSearch("", this.callback);
      } else {
        this.getProductionOrderCountByStatus(this.callback);
      }
    } else {
      if (this.cutDetail == "detail") {
        this.$refs.detailPage.getSmtOrderDetail(this.callback);
      } else if (this.cutDetail == "devices") {
        this.$refs.pcbaPage.getSmtOrderPcba("", this.callback);
      } else if (this.cutDetail == "status") {
        this.cutProStatus(this.proStatus, this.callback);
      } else if (this.cutDetail == "process") {
        this.$refs.sopPage.getSmtOrderSopSearch("", this.callback);
      } else if (this.cutDetail == "proLog") {
        this.$refs.logPage.getFactoryLogSearch("", false, this.callback);
      } else if (this.cutDetail == "QCReport") {
        this.$refs.QCReportPage.getProOrderQCReport("", this.callback);
      } else if (this.cutDetail == "uploadLog") {
        this.$refs.UploadLogPage.getUploadLogSearch("", false, this.callback);
      } else if (this.cutDetail == "RepairRecordPage") {
        this.$refs.RepairRecordPage.getRepairSearch("", this.callback);
      }
      
    }
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
.assembleOrder {
  .chartView {
    width: 1100px;
    height: 100%;
    margin: 40px auto;
    .echartBtn {
      width: 120px;
      padding-right: 20px;
      float: left;
      button {
        min-width: 68px;
        margin-left: 0;
        margin-bottom: 10px;
      }
    }
    .myEchart,
    .statusEchart,
    .partEchart {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .exceptionEchart {
      float: left;
      width: 950px;
      height: 680px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .anomalyReportByDays {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .anomalyReportByHours {
      float: left;
      width: 950px;
      height: 480px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
    .repairReportByDays {
      float: left;
      width: 950px;
      height: 680px;
      margin: 0 auto;
      border-radius: 5px;
      overflow: hidden;
    }
  }
  .tableView {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
.icon-yiguoqi {
  margin-right: 3px;
  color: #f56c6c
}
.expire {
  color: #f56c6c
}
.downIcon {
  /deep/.el-icon-d-arrow-right {
    transform: rotateZ(90deg);
  }
}
.devicesDownloadDrop {
  transform: translateX(15px);
  .el-dropdown-menu__item {
    padding: 0 16px;
  }
  /deep/.popper__arrow {
    left: 46% !important;
  }
}
}
</style>